// extracted by mini-css-extract-plugin
module.exports = {"layout":"fhs-brand_layout__M_use","brand":"fhs-brand_brand__Cl6HZ","sector":"fhs-brand_sector__zEVyT"};